export const isUsernameValid = (username: string) => {
  return /^[a-zA-Z0-9_-]*$/.test(username);
};
